export enum LearningPlanLessonStatus {
  Planned = 'PLANNED',
  Completed = 'COMPLETED',
}

export enum LearningPlanLessonType {
  CoreMath = 'CORE_MATH',
  CoreEla = 'CORE_ELA',
  FunPractice = 'FUN_PRACTICE',
  Homework = 'HOMEWORK',
  Assessment = 'ASSESSMENT',
  WrapUp = 'WRAP_UP',
  AlgebraOne = 'ALGEBRA_ONE',
  AlgebraTwo = 'ALGEBRA_TWO',
  Geometry = 'GEOMETRY',
  Precalculus = 'PRECALCULUS',
}

export enum LearningPlanCustomLessonType {
  HomeworkHelp = 'HOMEWORK_HELP',
  TestPreparation = 'TEST_PREPARATION',
  Custom = 'CUSTOM',
}

export enum LearningPlanLessonRequestType {
  Revisit = 'REVISIT',
  Change = 'CHANGE',
}

export enum LearningPlanUnitState {
  Completed = 'completed',
  Current = 'current',
  Upcoming = 'upcoming',
}
